import { useCallback } from 'react'
import {
  Dashboardv20240509Api,
  dashboardv20240509Client
} from '@sequencehq/api/dashboard/v20240509'
import { fetchQuery } from '@sequencehq/api'
import { apiQueryClient } from 'features/api/apiQueryClient'
import { MINUTES } from '@sequencehq/utils/dates'

export type v1ApiUser = Dashboardv20240509Api.GetUser.User

type UseLoadUser = () => (userId: string) => Promise<v1ApiUser | undefined>

export const useLoadUser: UseLoadUser = () => {
  const load = useCallback(async (userId: string) => {
    try {
      const user = await fetchQuery(
        apiQueryClient,
        dashboardv20240509Client.getUser,
        { id: userId },
        { staleTime: 10 * MINUTES }
      )

      return user ?? undefined
    } catch {
      return undefined
    }
  }, [])

  return load
}
